module.exports = __webpack_public_path__ + "img/ubbbrrru_cursor_pointer.b8d72510.png";